import Decimal from 'decimal.js'
import { createSelector } from 'reselect'
import { selectTotalBalance, selectUserCurrency } from '../user/selectors'

export const selectNewsArr = (state) => state.appReducer.positions.newsArr || []
export const selectPositionsTab = (state) => state.appReducer.positions.positionsTab || ''
export const selectPosition = (tab, key) => (state) => state.appReducer.positions.positionsAll[tab]?.[key] || null
export const selectPositionDefaultItem = (tab, key) => (state) =>
	state.appReducer.positions.positionsDefault[tab]?.[key] || null
export const selectPositionPnl = (key) => (state) =>
	state.appReducer.positions.positionsAll.open?.[key].pnl_close
export const selectPositionByID = (tab, id, key) => (state) =>
	state.appReducer.positions.positionsAll?.[tab]?.[id]?.[key] || null
export const selectPendingCanceled = (tab, id) => (state) =>
	state.appReducer.positions.positionsAll?.[tab]?.[id]?.canceled || false
export const selectOpenTP = (tab, id) => (state) =>
	state.appReducer.positions.positionsAll?.[tab]?.[id]?.takeProfit || null
export const selectOpenSL = (tab, id) => (state) =>
	state.appReducer.positions.positionsAll?.[tab]?.[id]?.stopLoss || null
export const selectPositionAssetName = (tab, id) => (state) =>
	state.appReducer.positions.positionsAll?.[tab]?.[id]?.asset_name || ''
export const selectPositionAssetClass = (tab, id) => (state) =>
	state.appReducer.positions.positionsAll?.[tab]?.[id]?.asset_class || ''
export const selectPositionAssetId = (tab, id) => (state) =>
	state.appReducer.positions.positionsAll?.[tab]?.[id]?.asset_id || ''
export const selectOpenPosition = (state) =>
	state.appReducer.positions.positionsAll?.['open'] || null
export const selectPositionDefault = (state) => state.appReducer.positions.positionsDefault || null
export const selectOpenTradeById = (key) => (state) => state.appReducer.positions.positionsDefault?.open?.[key] || null
export const selectCloseReason = (state) => state.appReducer.positions.closeReason
export const selectPositionInfo = (state) => state.appReducer.positions.positionInfo

export const selectPositionSearchString = (state) => state.appReducer.positions.positionSearchString
export const selectUsedMargin = (state) => state.appReducer.positions.totalAmountTradeOpenPosition
export const selectMarginCallSent = (state) => state.appReducer.positions.marginCallSent


export const selectTotalPnl = createSelector(
	[
		selectOpenPosition
	], (
		openPosition
	) => {
		let totalOpenSwaps = new Decimal(0)
		let totalPnl = 0
		let trade
		for (trade in openPosition) {
			totalPnl += +openPosition[trade].pnl_close
			if(trade.swap) {
				totalOpenSwaps = totalOpenSwaps.plus(trade.swap)
			}
		}
		return {totalOpenSwaps, totalPnl}
	}
)

export const selectTotalEquity = createSelector(
	[
		selectTotalBalance,
		selectTotalPnl
	], (
		totalBalance,
		totalPnl
	) => {
		return (new Decimal(totalBalance)).plus(totalPnl.totalPnl).plus(totalPnl.totalOpenSwaps)
	}
)
export const selectAvailableMargin = createSelector(
	[
		selectTotalEquity,
		selectUsedMargin
	], (
		totalEquity,
		totalAmountTradeOpenPosition
	) => {
		return totalEquity.minus(totalAmountTradeOpenPosition).toString()
	}
)
export const selectMarginRatio = createSelector(
	[
		selectTotalEquity,
		selectUsedMargin
	], (
		totalEquity,
		totalAmountTradeOpenPosition
	) => {
		let marginCallDelta = 0
		if (totalAmountTradeOpenPosition > 0) {
			marginCallDelta = totalEquity.div(totalAmountTradeOpenPosition).mul(100)
		}
		return marginCallDelta
	}
)

export const selectFilteredPositionsArr = createSelector(
	[
		selectPositionSearchString,
		selectPositionsTab,
		selectPositionDefault
	], (
		searchString,
		tab,
		positionAll
	) => {
		let arrIds = []
		if(positionAll && positionAll[tab]) {
			if (!searchString) {
				let key
				for (key in positionAll[tab]) arrIds.unshift(key)
				return arrIds
			} else {
				let key
				for (key in positionAll[tab]) {
					const trade = positionAll[tab][key]
					if (trade?.assetName?.toLowerCase().includes(searchString.toLowerCase()) ||
						trade?.id?.toString().includes(searchString.toLowerCase())) {
						arrIds.unshift(key)
					}
				}
				return arrIds
			}
		}
	}
)
export const selectFilteredPositionsAssetsSoId = createSelector(
	[
		selectPositionSearchString,
		selectPositionsTab,
		selectPositionDefault
	], (
		searchString,
		tab,
		positionAll
	) => {
		let assetSoIds = []
		if(positionAll && positionAll[tab]) {
			if (!searchString) {
				let key
				for (key in positionAll[tab]) assetSoIds.unshift('asset_' + positionAll[tab][key].assetId)
				return assetSoIds
			} else {
				let key
				for (key in positionAll[tab]) {
					const trade = positionAll[tab][key]
					if (trade?.assetName?.toLowerCase().includes(searchString.toLowerCase()) ||
						trade?.id?.toString().includes(searchString.toLowerCase())) {
						assetSoIds.unshift('asset_' + positionAll[tab][key].assetId)
					}
				}
				return assetSoIds
			}
		}
	}
)

export const selectTailDigitOfCurrency = createSelector(
	[
		selectUserCurrency
	],
	(
		currency
	) =>  (currency === 'BTC' || currency ===  'ETH') ? 8 : 2
)

export const selectFilteredNewsArr = createSelector(
	[
		selectPositionSearchString,
		selectPositionsTab,
		selectNewsArr
	], (
		searchString,
		positionsTab,
		newsArr
	) => {
		if (searchString && positionsTab === 'news') {
			return newsArr.filter(news => news.title.toLowerCase().includes(searchString.toLowerCase()) ||
				news.text.toLowerCase().includes(searchString.toLowerCase()) ||
				news.date.toLowerCase().includes(searchString.toLowerCase())
			)
		} else { return newsArr }
	}
)




